import React, { useRef, useEffect } from "react"
import ReactPlayer from "react-player"
import { useStore } from "./orbitStore"
// import { useStore } from "./orbitStore"
import "./Video.css"
import { Root } from "./Video.style"

const Video = ({ className, url, isVisible, playing, onEnd }) => {
  const player = useRef()
  // const [ready, setReady] = useState(false)
  const ready = useStore(state => state.ready)
  const setReady = useStore(state => state.setReady)

  useEffect(() => {
    if (!isVisible && ready !== false) {
      player.current.seekTo(0)
      // setTimeout(() => {
      // }, 50)
    }
  }, [ready, isVisible])
  return (
    <Root isVisible={isVisible}>
      <ReactPlayer
        ref={player}
        url={url}
        width="100%"
        height="100%"
        playing={playing}
        onEnded={onEnd}
        onReady={setReady}
        controls={false}
      />
    </Root>
  )
}

export default Video
